module.exports = __webpack_public_path__ + "static/media/icon-notation.ce0a7196.svg";